<template>
    <div>
        <div class="forgotpass content-container">
            <div class="header">
                <div class="title">Forgot Password</div>
            </div>            
            <div class="content">
                <form class="login" @submit.prevent="login">                
                    <div class="edit-row">
                        <label>Email or Username</label>
                        <input required v-model="email" placeholder="Name" />
                    </div>
                    <div class="edit-row">
                        <label>Password</label>
                        <input required v-model="password" type="password" placeholder="Password" />
                    </div>
                    <div class="edit-row">
                        <label>Confirm Password</label>
                        <input required v-model="passwordConfirm" type="password" placeholder="Password" />
                    </div>
                    <div class="right-aligned">
                        <span class="error-message">{{errorMessage}}</span>
                        <button @click="submit" type="submit">Update</button>
                    </div>             
                </form>
            </div>            
        </div> 
    </div>
</template>

<script>

    import api from '../../api/api'
    import dialogs from '../../modules/dialogs';

    export default {
        components: {
        },
        data() {
            return {
                code: null,
                password: null,
                passwordConfirm: null,
                email: null,
                errorMessage: "",
            }
        },
        methods: {
            submit: function() {

                let data = {};

                data.code = this.$route.query.code;
                data.user = this.email;
                data.password = this.password;
                data.passwordConfirm = this.passwordConfirm

                api.auth('/confirmForgotPassword', data).then(async () => {
                    await dialogs.alertAsync("Password reset, you may now log in");                    
                    this.$router.push("/login");
                }).catch((err) => {
                    this.errorMessage = err.data.message;
                });
            }
        }
    }

</script>
